// Gallery Carousel functionality for homepage
(function() {
    const carousel = document.querySelector('.gallery-carousel');
    if (!carousel) return;
    
    const slides = carousel.querySelectorAll('.gallery-slide');
    const prevBtn = carousel.querySelector('.gallery-nav-prev');
    const nextBtn = carousel.querySelector('.gallery-nav-next');
    const currentSpan = carousel.querySelector('.gallery-current');
    let currentIndex = 0;
    
    function showSlide(index) {
        slides.forEach(slide => slide.classList.remove('active'));
        slides[index].classList.add('active');
        currentSpan.textContent = index + 1;
    }
    
    function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
    }
    
    function prevSlide() {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        showSlide(currentIndex);
    }
    
    prevBtn.addEventListener('click', prevSlide);
    nextBtn.addEventListener('click', nextSlide);
    
    // Add keyboard navigation
    document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
    });
})();
